// @flow
import type { Event } from 'effector'
import type { WindowAppOptions } from '../types'
import { domain } from './domain'

export const updateAppOptions: Event<WindowAppOptions> = domain.createEvent('update app options')
